import React, { useEffect } from "react";
import { node } from "prop-types";

const WistiaVideo = ({ children }) => {
	useEffect(() => {
		if (!document.getElementById("wistia_script")) {
			const wistiaScript = document.createElement("script");
			wistiaScript.id = "wistia_script";
			wistiaScript.type = "text/javascript";
			wistiaScript.src = "https://fast.wistia.com/assets/external/E-v1.js";
			wistiaScript.async = true;
			document.body.appendChild(wistiaScript);
			/* eslint no-underscore-dangle: ["error", { "allow": ["_wq"] }] */
			window._wq = window._wq || [];
			// eslint-disable-next-line no-undef
			_wq.push({
				id: "_all",
				onReady(video) {
					video.bind("play", () => {
						// eslint-disable-next-line no-undef
						const allVideos = Wistia.api.all();
						allVideos.forEach(v => {
							if (v.uuid !== video.uuid) {
								v.pause();
							}
						});
					});
				},
			});
		}
	});
	return <div className="wistia-video-container">{children}</div>;
};

WistiaVideo.propTypes = {
	children: node.isRequired,
};

export default WistiaVideo;
